<template>
    <div class="auth-screen">
        <div class="auth-card">
            <img class="auth-logo" src="/logo.png" alt="Fytlix" />
            <h1 class="auth-title">{{ $t('loginTitle') }}</h1>
            <p class="auth-subtitle">{{ $t('loginSubtitle') }}</p>

            <div v-if="error" class="box-error">{{ error }}</div>

            <form @submit.prevent="submit">
                <label class="field">
                    <span class="field-label">{{ $t('email') }}</span>
                    <input class="field-input" type="email" inputmode="email" autocomplete="username"
                           v-model.trim="email" />
                </label>
                <label class="field">
                    <span class="field-label">{{ $t('password') }}</span>
                    <input class="field-input" type="password" autocomplete="current-password"
                           v-model="password" />
                </label>
                <button class="btn btn-primary btn-block btn-lg" type="submit" :disabled="!email || !password">
                    <i class="fa-solid fa-right-to-bracket"></i> {{ $t('login') }}
                </button>
            </form>

            <div class="auth-footer">
                <router-link :to="{ name: 'forgot-password' }">{{ $t('forgotPassword') }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { applyLanguage } from '@/plugins/lang.js';

export default {
    name: 'LoginView',
    data() {
        return {
            email: '',
            password: '',
            error: ''
        };
    },
    methods: {
        async submit() {
            this.error = '';
            const response = await this.$api.post('login', {
                email: this.email,
                password: this.password
            }, { client: false });

            if (!response.success) {
                this.error = this.$t('loginFailed');
                return;
            }

            this.$store.commit('setToken', response.data.token);
            this.$store.commit('setEmail', response.data.email);
            this.$store.commit('setClients', response.data.clients);
            if (response.data.language) applyLanguage(response.data.language);

            const clients = response.data.clients;
            if (clients.length === 0) {
                this.$store.commit('showToast', { message: this.$t('noClients'), type: 'error' });
                this.$router.push({ name: 'select-client' });
            } else if (clients.length === 1) {
                this.$store.commit('setSelectedClient', clients[0].client_id);
                this.$router.push({ name: 'home' });
            } else {
                this.$store.commit('setSelectedClient', null);
                this.$router.push({ name: 'select-client' });
            }
        }
    }
};
</script>
